import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PriceFilteringRuleAction } from '../priceFilteringRule.action';

export const reloadPriceFilteringRuleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PriceFilteringRuleAction.reload,
    PriceFilteringRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      PriceFilteringRuleAction.loadList.started(),
    ];
  }),
);
